export default "__VITE_ASSET__DQx_iljO__"